import {KeasyBootstrap} from './keasy-components/keasy-bootstrap';

declare let window: KeasyBootstrap;
window.paceOptions = {
    startOnPageLoad: false,
    ajax: false,
    document: false,
    eventLag: false,
    restartOnRequestAfter: false,
    restartOnPushState: false,
    ghostTime: 2500000
};